export default "__VITE_ASSET__BMueDlCh__"